import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, type Observable } from 'rxjs';
import { type PayLaterData } from '../../pages/pay-later/shared/types';

type LoadUrlResponse = { link: string };
type PayLaterStatusResponse = PayLaterData & { submittedAt: string };

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private readonly http = inject(HttpClient);

  getPaymentUrl(): Observable<string> {
    return this.http
      .get<LoadUrlResponse>(`api/v1/tickets/workup/current/payment-link`)
      .pipe(map((response) => response.link));
  }

  submitPayLater(formData: PayLaterData): Observable<PayLaterStatusResponse> {
    return this.http.post<PayLaterStatusResponse>(`api/v1/tickets/workup/current/pay-later`, {
      ...formData,
    });
  }

  getPayLaterStatus(): Observable<PayLaterStatusResponse> {
    return this.http.get<PayLaterStatusResponse>(`api/v1/tickets/workup/current/pay-later`);
  }
}
